<template>
  <RbInput
    v-model="money"
    :label="props.label"
    :placeholder="props.placeholder"
    :color="props.color"
    :primary="props.primary"
    :secondary="props.secondary"
    :disabled="props.disabled"
    :required="props.required"
    inputmode="numeric"
    @keyup="keyup"
  />
</template>

<script setup lang="ts">
import { withDefaults, ref, watch, onBeforeMount } from 'vue';
import { formatMoney } from '@/lib/Formatting';
import RbInput from './RbInput.vue';

const emits = defineEmits(['update:modelValue']);
const props = withDefaults(defineProps<{
  modelValue: any,
  label: string,
  color?: string,
  placeholder?: string,
  primary?: boolean,
  secondary?: boolean,
  disabled?: boolean,
  required?: boolean
}>(), {
  placeholder: '',
  color: 'rgba(0, 0, 0, 0.6)'
});

const money = ref('');

onBeforeMount(()=> {
  money.value = formatMoney(props.modelValue);
});

watch(() => props.modelValue, () => {
  money.value = formatMoney(props.modelValue);
});

watch(() => money.value, () => {
  emits('update:modelValue', formatMoney(money.value));
});

function keyup(event) {
  event.composedPath()[0].value = formatMoney(event.composedPath()[0].value);
}
</script>
